
import TextBlockMoreIconsBadges from '~/components/ui/TextBlockMoreIconsBadges.vue'
import ImageBlock from '~/components/ui/ImageBlock.vue'
export default {
  props: {
    reverse: {
      type: Boolean,
      required: false,
      default: false
    },
    isGCP: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    partnershipDetails() {
      return this.$store.state.partnership
    }
  },
  components: {
    TextBlockMoreIconsBadges,
    ImageBlock
  },
  beforeMounted() {
    this.$store.dispatch('loadPartnership', 'draft')
  }
}
